import { Directive, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';

@Directive({
  selector: '[appPhoneFormat]',
  host: {
    '(keyup)': 'validatePhoneNumber($event)',
    '(blur)': 'validatePhoneNumber($event)',
  },
})
export class PhoneFormatDirective {
  portalSetting: any;
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();

  constructor(
    private elementRef: ElementRef<HTMLInputElement>,
    portalSettingService: PortalSettingsService
  ) {
    this.portalSetting = portalSettingService.getPortalSettings();
  }

  validatePhoneNumber(event: any) {
    const mask = this.portalSetting.PhoneMask.ConfigValue;
    if (mask) {
      const maskLength = mask.replace(/[\D\s]/gi, '').length;
      const newVal = event.target.value.replace(/[\D\s]/gi, '');
      this.value = '';
      let maskPosition = 0;
      for (let i = 0; i < newVal.length; i++) {
        if (i >= maskLength) {
          break;
        }
        let maskCharacter = mask.charAt(maskPosition);
        if (maskCharacter == '') {
          break;
        }
        while (maskCharacter != '9') {
          this.value += maskCharacter;
          maskPosition++;
          maskCharacter = mask.charAt(maskPosition);
        }
        this.value += newVal.charAt(i);
        maskPosition++;
      }
      this.elementRef.nativeElement.setAttribute('value', this.value);
      this.valueChange.emit(this.value);
    }
  }
}
